import { Component, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { StatusComponent } from './../status/status.component';

@Component({
  selector: 'app-request-permission',
  templateUrl: './request-permission.component.html',
  styleUrls: ['./request-permission.component.scss']
})
export class RequestPermissionComponent {
  @ViewChild('status') status: StatusComponent;

  private resolve: any;
  private reject: any;
  private namespace: string;
  private action: string | string[];
  private msg: string;
  public users: { email: string, name: string }[] = [];
  public formulario: UntypedFormGroup;
  public error: string = null;

  constructor(
    private http: HttpClient,
    private formBuilder: UntypedFormBuilder,
    public bsModalRef: BsModalRef
  ) {
    this.formulario = this.formBuilder.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]]
    });
  }

  public setOption(resolve: any, reject: any, namespace: string, action: string | string[], msg: string = null) {
    this.resolve = resolve;
    this.reject = reject;
    this.namespace = namespace;
    this.action = action;
    this.msg = msg;

    this.status.setStatus({ info: 'Carregando lista usuario com permissão...', load: true });
    this.http.get<any[]>('/api/accounts/release-authorization/', { params: { namespace, action } }).pipe(
      map(res => res)
    ).subscribe(users => {
      if (users.length === 0) {
        this.status.setStatus({ warning: `Operação não permitida!\n ${this.msg}` });
        return;
      }

      this.users = users;
      this.formulario.patchValue({ username: users[0].email });
      this.status.hide();
    });
  }

  public optionDesc(user): string {
    return user.name || user.email;
  }

  public request(_event) {
    if (this.formulario.invalid) { return; }

    const data = Object.assign({ namespace: this.namespace, action: this.action }, this.formulario.value);

    this.http.post('/api/accounts/release-authorization/', data).pipe(
      map(res => res)
    ).subscribe(auth => {
      this.resolve(auth);
      this.bsModalRef.hide();
    }, err => this.error = 'Senha invalido.');
  }
}
